import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalNotice() {
  return (
    <div className="nuuma-container py-24 md:py-32">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-nuuma-primary hover:text-nuuma-secondary transition-colors mb-6 group"
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          Powrót do strony głównej
        </Link>
        <h1 className="text-3xl md:text-4xl font-display font-bold text-nuuma-primary mb-6">
          Informacje Prawne (Nota Prawna)
        </h1>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-nuuma-grey200 pb-6 mb-8">
          <div>
            <p className="text-nuuma-grey700 text-sm">
              Serwis internetowy: <strong>nuumagenetics.pl</strong>
            </p>
            <p className="text-nuuma-grey600 text-xs mt-1">
              Status dokumentu: Zgodny z przepisami prawa polskiego i hiszpańskiego (LSSI-CE)
            </p>
          </div>
        </div>

        <div className="space-y-8 text-nuuma-grey800 leading-relaxed text-sm md:text-base">
          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              1. WŁAŚCICIEL SERWISU
            </h2>
            <p>
              Zgodnie z przepisami hiszpańskiej ustawy nr 34/2002 z dnia 11 lipca o usługach społeczeństwa informacyjnego i handlu elektronicznym (LSSI-CE), informujemy, że właścicielem i administratorem niniejszego serwisu internetowego, dostępnego pod adresem <strong>nuumagenetics.pl</strong>, jest:
            </p>
            <ul className="space-y-3 list-none bg-nuuma-grey100 rounded-nuuma-m p-6 border border-nuuma-grey200">
              <li>
                <strong>Nazwa firmy:</strong> CITOLAB LABORATORIO CITODIAGNÓSTICO, S.L.
              </li>
              <li>
                <strong>Numer identyfikacji podatkowej (CIF):</strong> B-53238026
              </li>
              <li>
                <strong>Adres siedziby:</strong> Avda. de Dénia, 76 – 03016 · Alicante · Hiszpania
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              2. CEL SERWISU
            </h2>
            <p>
              Za pośrednictwem niniejszego serwisu internetowego Użytkownicy uzyskują dostęp do różnorodnych treści, materiałów oraz informacji udostępnianych bezpośrednio przez <strong>nuumagenetics.pl</strong> lub przez zewnętrznych dostawców usług i treści.
            </p>
            <p>
              <strong>nuumagenetics.pl</strong> zastrzega sobie prawo do modyfikowania w dowolnym momencie wyglądu, konfiguracji oraz lokalizacji serwisu internetowego, jak również wprowadzania zmian w strukturze prezentowanych treści, oferowanych produktów oraz świadczonych usług.
            </p>
            <p>
              Dostęp, przeglądanie oraz korzystanie z serwisu internetowego <strong>nuumagenetics.pl</strong> są równoznaczne z pełną akceptacją przez Użytkownika niniejszych Ogólnych Warunków. W rozumieniu niniejszego dokumentu za „Użytkownika” uważa się każdą osobę, która uzyskuje dostęp, przegląda, korzysta lub uczestniczy w usługach i działaniach (zarówno bezpłatnych, jak i odpłatnych) realizowanych w ramach Serwisu.
            </p>
            <p>
              Niniejsza Informacja prawna reguluje zasady dostępu, przeglądania i korzystania z Serwisu, bez uszczerbku dla prawa <strong>nuumagenetics.pl</strong> do wprowadzenia szczególnych warunków (np. regulaminów) dla konkretnych usług lub zamawiania określonych produktów oferowanych Użytkownikom.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              3. WARUNKI DOSTĘPU
            </h2>
            <p>
              Dostęp do serwisu internetowego jest co do zasady swobodny i bezpłatny. Korzystanie z niektórych dedykowanych usług może jednak wymagać uprzedniego uwierzytelnienia Użytkownika poprzez podanie unikalnej nazwy użytkownika (loginu) oraz hasła.
            </p>
            <p>
              W sytuacjach, w których dostęp do określonych treści lub korzystanie z wybranej usługi wymaga podania danych osobowych, Użytkownicy gwarantują ich prawdziwość, dokładność, autentyczność oraz aktualność. <strong>nuumagenetics.pl</strong> przetwarza te dane w sposób zautomatyzowany, zgodnie z ich charakterem i przeznaczeniem, na zasadach i warunkach szczegółowo określonych w zakładce <Link to="/polityka-prywatnosci" className="text-nuuma-secondary hover:underline font-semibold">Polityka prywatności</Link>.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              4. OGÓLNE WARUNKI UŻYTKOWANIA
            </h2>
            <p>
              Użytkownik zobowiązuje się do właściwego, zgodnego z prawem i przeznaczeniem korzystania z serwisu internetowego, a także z jego treści i usług. Korzystanie to musi być zgodne z obowiązującymi przepisami prawa, niniejszą Informacją prawną, ogólnie przyjętymi normami moralnymi, dobrymi obyczajami oraz zasadami porządku publicznego.
            </p>
            <p>
              Zabrania się całkowitego lub częściowego powielania, kopiowania oraz reprodukowania treści zawartych na tej stronie internetowej bez wyraźnego podania źródła lub uzyskania uprzedniej zgody właściciela. Dostęp, przeglądanie i korzystanie z Serwisu odbywa się na wyłączną odpowiedzialność Użytkownika, który w szczególności zobowiązuje się do powstrzymania od następujących działań:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Zwielokrotniania, kopiowania, rozpowszechniania, publicznego udostępniania (w jakiejkolwiek formie komunikacji publicznej), przekształcania lub modyfikowania treści Serwisu, chyba że posiada się wyraźną zgodę właściciela odpowiednich praw autorskich lub działanie takie jest wprost dozwolone przez przepisy prawa.
              </li>
              <li>
                Wykorzystywania treści Serwisu, a w szczególności wszelkiego rodzaju informacji uzyskanych za jego pośrednictwem, do wysyłania materiałów reklamowych, komunikatów w celu sprzedaży bezpośredniej lub w jakimkolwiek innym celu komercyjnym, a także do rozsyłania niechcianych wiadomości masowych (tzw. spamu) do wielu osób, niezależnie od ich celu. Zabrania się również jakiejkolwiek komercjalizacji lub dalszego bezprawnego dystrybuowania tych informacji.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              5. GROMADZENIE DANYCH STATYSTYCZNYCH I PLIKI COOKIE
            </h2>
            <p>
              W celu zapewnienia najwyższej jakości świadczonych usług oraz ułatwienia korzystania z Serwisu, system zapisuje anonimowe dane statystyczne dotyczące ruchu na stronie, takie jak liczba odwiedzonych stron, łączna liczba wizyt, aktywność odwiedzających.
            </p>
            <p>
              W tym celu wykorzystywane są pliki cookies. Serwis <strong>nuumagenetics.pl</strong> może wykorzystywać pliki cookie (tzw. ciasteczka) podczas przeglądania stron przez Użytkownika.
            </p>
            <p>
              Pliki cookie to niewielkie pliki tekstowe wysyłane do przeglądarki przez serwer internetowy w celu rejestrowania aktywności Użytkownika w Serwisie. Pliki cookie stosowane przez <strong>nuumagenetics.pl</strong> są powiązane wyłącznie z anonimowym Użytkownikiem oraz jego urządzeniem końcowym i same w sobie nie pozwalają na identyfikację tożsamości ani nie dostarczają danych osobowych Użytkownika.
            </p>
            <p>
              W zależności od konfiguracji swojej przeglądarki internetowej, Użytkownik może otrzymywać powiadomienia o przesyłaniu plików cookie, a także ma możliwość całkowitego zablokowania ich instalacji na dysku twardym swojego komputera lub urządzenia mobilnego. Szczegółowe informacje na temat zarządzania plikami cookie można znaleźć w instrukcji obsługi oraz sekcji pomocy używanej przeglądarki internetowej.
            </p>
            <p>
              Prawidłowe korzystanie z podstawowych funkcji serwisu internetowego nie wymaga obowiązkowego wyrażenia zgody na instalację wszystkich plików cookie wysyłanych przez serwer. Szczegóły dotyczące stosowania ciasteczek opisuje nasza <Link to="/polityka-cookies" className="text-nuuma-secondary hover:underline font-semibold">Polityka plików cookie</Link>.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              6. TREŚCI I LINKI ZEWNĘTRZNE (HIPERŁĄCZA)
            </h2>
            <p>
              Wszelkie treści, struktura organizacyjna, opisy oraz dobór linków zewnętrznych i materiałów informacyjnych zawartych w Serwisie zostały przygotowane, wybrane i skoordynowane bezpośrednio przez zespół <strong>nuumagenetics.pl</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

